import styled, { css } from 'styled-components'

export const Content = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacings.xlarge};
    flex: 1 0 auto;
    background: ${theme.colors.mainBg};

    @media print {
      margin: 0 !important;
    }
  `}
`
